/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Wed May 08 2024
 **/

import { useState } from "react";

import { _P, _T } from "@rfice/language";
import { Button, Row, Typography } from "@/frameworks/designStuff/components";

import * as S from "./emotion";

export default function GroupBlock({
	blockedUserList,
	variant
}: {
	blockedUserList: Users.People.Data[];
	variant: ChatUI.Size;
}) {
	const [show, setShow] = useState(true);

	const close = () => {
		setShow(false);
	};

	if (!show) return;
	return (
		<S.BlockInformationWrapper gap={8} variant={variant}>
			<Row css={{ width: "100%" }} horizonAlign="distribute">
				<Typography css={{ width: "100%" }}>
					{_P(
						"차단된 {{name}} 님은 더이상 나에게 다이렉트 메시지를 보낼 수 없습니다. 차단해제 후 확인해주세요.",
						{ name: blockedUserList.map((v) => v.name).join(", ") }
					)}
				</Typography>
				<Button.Icon filled="transparent" name="Close24" size="medium" onClick={close} />
			</Row>
			<Row css={{ paddingRight: "32px", alignSelf: "flex-end" }}>
				<Button onClick={close}>{_T("확인")}</Button>
			</Row>
		</S.BlockInformationWrapper>
	);
}
